<template>
  <div class="mt-4">
    <total-experience-chart
      v-if="getTotalExperienceYesData && yesDataset"
      class="pb-2"
      :survey-type="'YES'"
      :title="'Engagement Score'"
      :total-experience-data="yesDataset"
      :years="getYearsYes"
      @change-year="handleChangeYearYes"
    ></total-experience-chart>
    <section v-else class="loading-container  position-relative">
      <the-loading />
    </section>
    <total-experience-chart
      v-if="getTotalExperienceRedData && redDataset"
      :survey-type="'RED'"
      :title="'Experience Score'"
      :total-experience-data="redDataset"
      :years="getYearsRed"
      @change-year="handleChangeYearRed"
    ></total-experience-chart>
    <section v-else class="loading-container  position-relative">
      <the-loading />
    </section>
  </div>
</template>

<script>
import TotalExperienceChart from "@/components/dashboard/surveys-charts/group/total-experience-chart.vue";
import { mapGetters } from "vuex";

export default {
  name: "SurveyScores",
  components: {
    TotalExperienceChart,
  },
  data() {
    return {
      yesDataset: [],
      redDataset: [],
    };
  },
  computed: {
    ...mapGetters("mainStats", [
      "getTotalExperienceRedData",
      "getTotalExperienceYesData",
      "getYearsYes",
      "getYearsRed",
      "getYesSelectedYear",
      "getRedSelectedYear",
    ]),
  },
  methods: {
    async loadTotalExperience(year, type) {
      await this.$store.dispatch("mainStats/loadTotalExperience", {
        surveyType: type,
        year: year,
      });
    },

    async loadSurveysYears(type) {
      await this.$store.dispatch("mainStats/fetchSurveyTypeYears", {
        surveyType: type,
      });
    },

    handleChangeYearYes(year) {
      this.yesDataset = this.getTotalExperienceYesData.filter(
        (item) => item.year == year
      );
      this.$store.commit("mainStats/setYesSelectedYear", year);
    },

    handleChangeYearRed(year) {
      this.redDataset = this.getTotalExperienceRedData.filter(
        (item) => item.year == year
      );
      this.$store.commit("mainStats/setRedSelectedYear", year);
    },
  },
  async mounted() {
    try {
      if (!this.getYearsYes) await this.loadSurveysYears("YES");
      if (!this.getYesSelectedYear) {
        const currentYesYear = this.getYearsYes[this.getYearsYes.length - 1];
        this.$store.commit("mainStats/setYesSelectedYear", currentYesYear);
      }
      if (!this.getTotalExperienceYesData)
        await this.loadTotalExperience(this.getYesSelectedYear, "YES");
      this.yesDataset = this.getTotalExperienceYesData.filter(
        (item) => item.year == this.getYesSelectedYear
      );
      if (!this.getYearsRed) await this.loadSurveysYears("RED");
      if (!this.getRedSelectedYear) {
        const currentRedYear = this.getYearsRed[this.getYearsRed.length - 1];
        this.$store.commit("mainStats/setRedSelectedYear", currentRedYear);
      }
      if (!this.getTotalExperienceRedData)
        await this.loadTotalExperience(this.getRedSelectedYear, "RED");
      this.redDataset = this.getTotalExperienceRedData.filter(
        (item) => item.year == this.getRedSelectedYear
      );
    } catch (error) {
      this.$store.dispatch("dialog/showErrorDialog", {
        error: error,
      });
    }
  },
};
</script>

<style lang="scss" scoped></style>
